import { TiptapEditor } from "../tiptap/TiptapEditor";

export function Editor({
  editorSerializedState,
  onSerializedChange,
  readOnly = false,
}: {
  editorState?: any;
  editorSerializedState?: any;
  onChange?: (editorState: any) => void;
  onSerializedChange?: (editorSerializedState: any) => void;
  readOnly?: boolean;
}) {
  return (
    <TiptapEditor
      content={editorSerializedState}
      onJSONChange={onSerializedChange}
      readOnly={readOnly}
      variant="full"
    />
  );
}
